import SharedTranslations, {
  TranslationField,
} from "shared/components/Translations";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { LocaleCode } from "shared/types/languages";
import { useThemeTagDetails } from "../../../../context";
import { ManagedTranslations } from "../../../../context/types";

const Translations = () => {
  const { tagName, translations, setTranslations } = useThemeTagDetails();

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.TagName,
      label: ManagedTranslations.TagName,
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={
            language === LocaleCode.en ? tagName?.input.value : value
          }
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              tagName?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;
